import React, { useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { enqueueSnackbar } from 'actions';
import ModalDialog from '../../../../../components/ModalDialog/ModalDialog.js';
import SiteTrackerDialogForm from './components/SiteTrackerDialogForm';
import {
	SetFormState, ResetFields, GetSiteDetails, GetComments, GetSiteAttachments, GetSiteDropdowns,
	EditSiteDetails, CreateSite,
	ToggleSiteTrackerDialog
} from '../../../actions/SiteTrackerActions';

const SiteTrackerDialog = (props) => {
	const { author, open, onClose, onApply, className, ...rest } = props;
	const dispatch = useDispatch();
	const tableId = useSelector((state) => state.siteTrackerReducer.tableId);
	const selectedDates = useSelector((state) => state.siteTrackerReducer.selectedDates);
	const selectedFailures = useSelector((state) => state.siteTrackerReducer.selectedFailures);
	const setFormState = formState => dispatch(SetFormState(formState));
	const formState = useSelector((state) => state.siteTrackerReducer.formState);
	const userId = useSelector(state => state.session.user.id);
	const title = tableId ? 'Save site' : 'Create site';
	const confirmLabel = tableId ? 'Save' : 'Create';

	const _onConfirmClick = () => {
		setFormState({ ...formState, values: { ...formState.values, submit: true } });

		if (formState.isValid) {
			const object = { ...formState.values, userId, selectedDates, selectedFailures };
			if (tableId) {
				dispatch(EditSiteDetails(object));
				dispatch(ToggleSiteTrackerDialog(false));
				dispatch(enqueueSnackbar({ message: 'Site details saved', options: { variant: 'info' } }));
			} else {
				dispatch(CreateSite(object));
				dispatch(ToggleSiteTrackerDialog(false));
				dispatch(enqueueSnackbar({ message: 'Site created', options: { variant: 'info' } }));
			}
		}
	};

	const getData = useCallback(() => {
		dispatch(GetSiteDropdowns());
	}, []);

	useEffect(() => {
		getData();
		if (tableId) {
			dispatch(GetSiteDetails(userId, tableId));
			dispatch(GetComments(tableId));
			dispatch(GetSiteAttachments(userId, tableId));
			dispatch(ResetFields());
		}
	}, [tableId]);

	return (
		<ModalDialog
			maxWidth="xl"
			onClose={onClose}
			open={open}
			title={title}
			confirmLabel={confirmLabel}
			onConfirmClicked={_onConfirmClick}
		>
			<SiteTrackerDialogForm tableId={tableId} />
		</ModalDialog>
	);
};

SiteTrackerDialog.propTypes = {
	author: PropTypes.object,
	className: PropTypes.string,
	onApply: PropTypes.func,
	onClose: PropTypes.func,
	open: PropTypes.bool,
};

export default SiteTrackerDialog;
